import { useTranslation } from "react-i18next";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { HealthServicesLeftMenuList } from "../utils/constants";
import { RenderNavItem } from "../components/RenderNavItem";

const Health_Slaughter_House = () => {
  const { t } = useTranslation();
  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="img" />
          <div className="container">
            <div className="section-main-heading2">
              <h4 className="fontSizeClass"> </h4>
            </div>
          </div>
        </div>
      </section>
      {/* End Slider */}
      <section className="section inner-pad1">
        <div className="container ">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu  min-height-400">
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {HealthServicesLeftMenuList.map((item, index) => (
                      <RenderNavItem item={item} index={index} t={t} />
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="container">
                <div className="row">
                  <div className="inner-title2 bas">
                    <h3 className="fontSizeClass">
                      {t("SLAUGHTER HOUSE – 4")}
                    </h3>
                  </div>
                  <div className="about-head1">
                    <div className="dig-login1 dig-login2">
                      <form>
                        <div className="log-form inner-log-form health-frm">
                          <h3 className="fontSizeClass">
                            {t("SLAUGHTER HOUSE - INFORMATION")}
                          </h3>
                          <div className="row">
                            <div className="col-lg-12 col-md-12 form-group pt-2">
                              <div className="list-of-forms">
                                <h6 className="fontSizeClass">
                                  {t(
                                    "Slaughtering of large & small animals, pigs, sheep, goats etc"
                                  )}
                                  .
                                </h6>
                              </div>
                            </div>
                            <label
                              htmlFor="exampleFormControlInput1"
                              className="form-label"
                            >
                              &nbsp;
                            </label>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Health_Slaughter_House;
